import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";


import {CoreJpatsServices} from "../../../../../shared/core-jpats/services/core-jpats.services";
import {LookupService} from "../../../../../../../shared/core/services/lookup.service";
import {UserManagementService} from "../../../../../shared/core-jpats/services/user-management.service";

@Component({
  selector: 'modal-add-fcc',
  templateUrl: './modal-add-fcc.component.html',
  styleUrls: ['./modal-add-fcc.component.scss']
})
export class ModalAddFccComponent implements OnInit {

  @Output() complete = new EventEmitter();

  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private coreJpatsService: CoreJpatsServices,
    private lookupService: LookupService,
    private userManagementService: UserManagementService
  ) { }

  searchResults: any[] = [];
  form: FormGroup;
  states: any[] = [];
  firstItem: number = 0;
  pageSize: number = 5;

  isEditMode = false;
  userData: any = {};
  ngOnInit() {
    this.search();
    this.userManagementService.getCurrentCachedUser().subscribe((userData)=>{
      this.userData = userData;

    });
    this.setupForm();


  }

  setupForm(){
    this.form = this.fb.group({
      fccKey: null,
      apoeLocationKey: null,
      metadataKey: null,
      FCCName: [null, Validators.required],
      State: [null, Validators.required],
      Director: null,
      MedicalCenter: null,
      EmergencyManager: null
    })
  }

  search(){

    this.coreJpatsService.getAPOEFcc("").subscribe((res:any) =>{
      this.states = this.lookupService.get("StateProvinces");
      this.searchResults = res;
    });
  }

  add(){
    this.isEditMode = !this.isEditMode;
    this.setupForm();
  }

  edit(row){
    this.form.setValue({
      fccKey: row.fccKey,
      apoeLocationKey: row.apoeLocationKey || '',
      FCCName: row.fccName,
      State: row.state,
      Director: row.director,
      MedicalCenter: row.medicalCenter,
      EmergencyManager: row.emergencyManager,
      metadataKey: row.metadataKey,
    });
    this.isEditMode = !this.isEditMode;
  }
  save(){
    this.coreJpatsService.saveFcc(this.form.value).subscribe((res) => {
      this.search();
    });
    this.isEditMode = !this.isEditMode;
  }
  cancel(){
    this.isEditMode = !this.isEditMode;
  }
  select(row){
    this.userManagementService.updateLocation({
      fccKey:row.fccKey,
      locationKey:row.apoeLocationKey,
      operationKey:this.userData.operation.key}).subscribe((res)=>{
      this.bsModalRef.hide();
    });
    this.bsModalRef.hide();
    this.isEditMode = !this.isEditMode;
  }
  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }
}
